<script>
    import { onMount, onDestroy } from "svelte";
    let tweetContainer;
    export let tweetUrl;

    let scriptTag;

    onMount(() => {
        window.handleTweetData = (data) => {
            tweetContainer.innerHTML = data.html;
            twttr.widgets.load(tweetContainer);
            tweetContainer.classList.remove('hidden');
        };

        scriptTag = document.createElement('script');
        scriptTag.src = `https://publish.twitter.com/oembed?url=${tweetUrl}&callback=handleTweetData&omit_script=1&theme=dark&chrome=noborders&maxwidth=180`;
        document.body.appendChild(scriptTag);
    });

    onDestroy(() => {
        if (scriptTag) {
            document.body.removeChild(scriptTag);
        }
        tweetContainer.innerHTML = '';
        delete window.handleTweetData; // remove the global function
    });
</script>

<div bind:this={tweetContainer} class="hidden"></div>
